import React from 'react'
import {
  BooleanInput,
  List,
  Datagrid,
  TextField,
  EditButton,
  Create,
  SimpleForm,
  FileInput,
  FileField,
  TextInput,
  Edit,
  CreateProps,
  EditProps,
  ListProps,
  ArrayInput,
  SimpleFormIterator,
  DateInput,
  DateField
} from 'react-admin'
import * as Yup from 'yup'

import { validate } from '../../schema/validate'

import { CustomToolbar } from './CustomToolbar'

const createSchema = Yup.object().shape({
  id: Yup.string().required(),
  name: Yup.string().required(),
  description: Yup.string().nullable(),
  allowExport: Yup.boolean(),
  file: Yup.object().required()
})

const updateSchema = createSchema.shape({
  file: Yup.object().nullable()
})

export const StudyCreate: React.FC<CreateProps> = (props) => {
  return (
    <Create {...props}>
      <SimpleForm validate={validate(createSchema)}>
        <TextInput source="id" />
        <TextInput source="name" />
        <TextInput source="description" />
        <DateInput source="startDate" />
        <DateInput source="endDate" />
        <BooleanInput
          label="Allow export"
          source="allowExport"
          defaultValue={false}
        />
        <FileInput accept="text/csv" source="file" label="CSV file">
          <FileField source="src" title="title" />
        </FileInput>
      </SimpleForm>
    </Create>
  )
}

export const StudyEdit: React.FC<EditProps> = (props) => {
  return (
    <Edit {...props}>
      <SimpleForm validate={validate(updateSchema)} toolbar={<CustomToolbar />}>
        <TextInput disabled source="id" />
        <DateField label="Luotu" source="createdOn" />
        <TextInput label="Nimi" source="name" />
        <TextInput label="Kuvaus" source="description" multiline />
        <DateInput source="startDate" />
        <DateInput source="endDate" />
        <BooleanInput label="Allow export" source="allowExport" />
        <ArrayInput source="segments">
          <SimpleFormIterator disableAdd disableRemove disableReordering>
            <TextInput label="Segmentti" source="name" />
          </SimpleFormIterator>
        </ArrayInput>
        <h3>Projektit</h3>
        <List
          resource="project"
          filter={{ studyId: props.id }}
          perPage={100}
          actions={<></>}
          pagination={<></>}
          bulkActionButtons={false}
        >
          <Datagrid>
            <TextField source="name" />
          </Datagrid>
        </List>
      </SimpleForm>
    </Edit>
  )
}

const postFilters = [
  <TextInput key="name" label="Nimi" source="name" alwaysOn />,
  <TextInput key="description" label="Kuvaus" source="description" alwaysOn />
]

export const StudyList: React.FC<ListProps> = (props) => (
  <List filters={postFilters} {...props} bulkActionButtons={false}>
    <Datagrid rowClick="edit">
      <TextField source="name" />
      <DateField source="createdOn" />
      <TextField source="description" />
      <EditButton />
    </Datagrid>
  </List>
)
